import { useActionsTrack } from "@/_old/features/analytics";
import { DashboardSection } from "@/dashboard/components/dashboard-ds";
import { useDashboardFilters } from "@/dashboard/store/useDashboardFilters";
import { TabBar } from "@woba/ds-web-next";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { DashboardRankingsCitiesDataTable } from "./components/cities-data-table";
import { DashboardRankingsSheet } from "./components/dashboard-rankings-sheet";
import { DashboardRankingsGroupsDataTable } from "./components/groups-data-table";
import { DashboardRankingsSpacesDataTable } from "./components/spaces-data-table";
import { DashboardRankingsUsersDataTable } from "./components/users-data-table";

type RankingsTab = "spaces" | "cities" | "users" | "groups";

const TAB_EVENTS = {
  spaces: "DASHBOARD_RANKINGS_SPACES_TAB_CLICK",
  cities: "DASHBOARD_RANKINGS_CITIES_TAB_CLICK",
  users: "DASHBOARD_RANKINGS_USERS_TAB_CLICK",
  groups: "DASHBOARD_RANKINGS_GROUPS_TAB_CLICK",
} as const;

const isRankingsTab = (value: string): value is RankingsTab =>
  value in TAB_EVENTS;

/**
 * Rankings do Painel (Figma 6037:11014): abas no TabBar do Workbase DS,
 * tabela no DataTable do DS e "Carregar mais" abrindo o sheet completo.
 */
export const DashboardRankings = () => {
  const [translate] = useTranslation(["dashboard"]);
  const { onActionClick } = useActionsTrack();
  const { filters } = useDashboardFilters();
  const [tab, setTab] = useState<RankingsTab>("spaces");

  const handleRankingsTabChange = useCallback(
    (value: string) => {
      if (!isRankingsTab(value)) return;
      setTab(value);
      onActionClick(TAB_EVENTS[value], "DASHBOARD");
    },
    [onActionClick],
  );

  return (
    <DashboardSection
      title={translate("dashboard-rankings-title")}
      data-testid="dashboard-rankings"
    >
      <TabBar
        accessibilityLabel={translate("dashboard-rankings-title") as string}
        value={tab}
        onValueChange={handleRankingsTabChange}
        items={[
          {
            value: "spaces",
            label: translate("dashboard-rankings-spaces-tab") as string,
            leading: false,
          },
          {
            value: "cities",
            label: translate("dashboard-rankings-cities-tab") as string,
            leading: false,
          },
          {
            value: "users",
            label: translate("dashboard-rankings-users-tab") as string,
            leading: false,
          },
          {
            value: "groups",
            label: translate("dashboard-rankings-groups-tab") as string,
            leading: false,
          },
        ]}
      />

      {tab === "spaces" && (
        <DashboardRankingsSpacesDataTable filters={filters} />
      )}
      {tab === "cities" && (
        <DashboardRankingsCitiesDataTable filters={filters} />
      )}
      {tab === "users" && <DashboardRankingsUsersDataTable filters={filters} />}
      {tab === "groups" && (
        <DashboardRankingsGroupsDataTable filters={filters} />
      )}

      <div>
        <DashboardRankingsSheet />
      </div>
    </DashboardSection>
  );
};
